export enum TableSortOrder {
	Ascending = 'asc',
	Descending = 'desc',
}